/**
 * @author 3173
 * @description 远程检核管理页面配置
 * @Date  2020/8/12
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool, utils_tool } from '../../../tool';
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;
import { exportExcel } from "./exportExcelUtil/exportExcelUtil";
import { element } from "prop-types";
let { checkStrLength } = utils_tool;


class RemoteAuthList extends WizContainer {
  componentName = 'remoteAuthList';
  constructor(props) {
    super(props);
    this.state = {
      lookDownTimestamp : new Date().getTime()
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 25
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['orgName'] = checkStrLength(val['orgName'], len);
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '检核项目',
        field: 'remoteAuthName',
        width: 30,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
          font: {}
        },
      },
      {
        headerName: '组织名称',
        field: 'brandName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      // {  //20200823 测试反馈不合理点 和需求确认后先注释 --3173
      //   headerName: '考评场次',
      //   field: 'studentCount',
      //   width: 10,
      //   cellStyle: {
      //     textAlign: 'left',
      //   },
      //   style: {
      //     alignment: { vertical: 'middle', horizontal: 'left' },
      //   },
      // },
      {
        headerName: '考卷上传人',
        field: 'examCreatorName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '上传日期',
        field: 'examCreateDate',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '学员账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },
      },
      {
        headerName: '学员名字',
        field: 'fullName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '经销商简称',
        field: 'dealerName',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '经销商代码',
        field: 'dealerCode',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '考卷',
        field: 'authExamName',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let headerList = data.headerList;
      let resultList = data.resultList;
      let remoteAuthName = data.remoteAuthName;

      if (headerList && headerList instanceof Array) {
        headerList.forEach(e => {
          e.cellStyle = { textAlign: 'left' };
          e.style = { alignment: { vertical: 'middle', horizontal: 'left' } };
          columnDefs.push(e)
        })
      }

      WizBrowserExport({
        title: remoteAuthName ? remoteAuthName : '' + '考核成绩',
        sheetName: remoteAuthName ? remoteAuthName : '' + '考核成绩',
        columns: columnDefs.filter((_, index) => index),
        rows: resultList && resultList instanceof Array ? resultList : [],
        filename: (remoteAuthName ? remoteAuthName : '') + '考核成绩.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFileNew(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let headList = o.data['headList']
      let dataList = o.data['dataList']
      let remoteAuthName = o.data['remoteAuthName']
      if (o.data['type'] === 0) {
        WizBrowserExport({
          title: remoteAuthName ? remoteAuthName : '' + '分析报告',
          sheetName: remoteAuthName ? remoteAuthName : '' + '分析报告',
          columns: handleExportHeader(headList).filter((_, index) => index),
          rows: dataList,
          filename: (remoteAuthName ? remoteAuthName : '') + '分析报告.xlsx',
        })
      } else {
        let headListNew = [];
        let dataListNew = [];
        let _getChildren = (data) => {
          if (data.list && data.list.length > 0) {
            let listNew = [];
            data.list.forEach(ele => {
              ele.title = ele.name
              ele.dataIndex = ele.key
              ele.children = _getChildren(ele);
              listNew.push(ele);
            })
            return listNew
          }
        }
        headList.forEach(e => {
          e.title = e.name
          e.dataIndex = e.key
          e.children = _getChildren(e);
          headListNew.push(e)
        })
        dataList.forEach(e => {
          for(var i in e){
            e[i] = e[i]==="" ? 0 : e[i]
          }
          e.title = e.remoteAuthName
          e.dataIndex = e.key
          e.children = _getChildren(e);
          dataListNew.push(e)
        })
        exportExcel(
          headListNew,
          dataListNew,
          remoteAuthName ? remoteAuthName : '' + '分析报告',
          '分析报告'
        )
      }
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListExport(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '检核项目',
        field: 'name',
        width: 35,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
          font: {}
        },
      },
      {
        headerName: '检核类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '品牌',
        field: 'orgName',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {  //20200823 测试反馈不合理点 和需求确认后先注释 --3173
        headerName: '考评场次',
        field: 'studentCount',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '考卷上传人',
        field: 'examCreatorName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '上传日期',
        field: 'examCreateDate',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left' },
        },
      },
      {
        headerName: '考卷数',
        field: 'examCount',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },
      },
      {
        headerName: '通过分数',
        field: 'passScore',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },
      },
      {
        headerName: '创建人',
        field: 'creator',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },
      },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        if(e.type===1){
          e.examCount = e.examCount > 0 ? 1 : 0
        }
        e['type'] === 0 ? e['type'] = "远程认证" : e['type'] === 1 ?  e['type'] = "远程评估" : e['type'] = "NEV认证";
      })
      WizBrowserExport({
        title: '检核项目',
        sheetName: '检核项目',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '检核项目.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig(this);
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:_templateConfig,
      apiDataFormat: {
        enable: this._handleCMD,
        report: this._handleFile,
        reportNew: this._handleFileNew,
        list: this._handleListData,
        export: this._handleListExport,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RemoteAuthList);
